<template>
  <v-col cols="5" sm="5" md="5" class="recipes">
    <div class="recipes-frame">
      <v-list dense class="recipes">
        <v-list-item
          dense
          class="recipe"
          v-for="recipe in recipes"
          draggable="true"
          @dragstart.stop="putDraggingRecipe(recipe)"
          v-if="
            recipe.ordername
              .trim()
              .includes(getOrderName($store.state.searchRecipe.trim()))
          "
        >
          <v-list-item-content>
            <span>{{ recipe.name }}</span>
          </v-list-item-content>
          <div v-if="recipe.comments.length > 0" class="data-frame">
            <div class="rating-frame">
              <v-rating
                class="stars"
                half-increments
                readonly
                small
                dense
                color="green"
                background-color="green"
                :value="recipe.rating"
              ></v-rating>
              <span class="rating"
                >({{ (2 * recipe.rating).toFixed(2) }})
              </span>
            </div>
            <span @click="$router.push('recipe/' + recipe.id)" class="comments"
              >{{ recipe.comments.length }} Comentarios</span
            >
          </div>
          <span v-if="recipe.comments.length === 0" class="no-comments"
            >No hay comentarios</span
          >
        </v-list-item>
      </v-list>
    </div>
  </v-col>
</template>

<script>
import firebase from "firebase";

export default {
  data() {
    return {
      db: firebase.firestore(),
      recipes: [],
    };
  },
  created: function () {
    this.db.collection("recipes").onSnapshot((refs) => {
      this.recipes = [];
      refs.forEach((ref) => {
        this.recipes.push(ref.data());
      });
      this.recipes.sort((a, b) => {
        if (a.ordername > b.ordername) {
          return 1;
        } else {
          return -1;
        }
      });
    });
  },
  methods: {
    putDraggingRecipe: function (recipe) {
      this.$store.commit("putDraggingRecipe", recipe);
    },
    getOrderName: function (str) {
      var theString = str.toLowerCase();
      return theString.replace(/[áàäâéèëêíìïîóòöôúùüûñç]/gi, (x) => {
        if ("áàäâ".indexOf(x) > -1) return "a";
        if ("éèëê".indexOf(x) > -1) return "e";
        if ("íìïî".indexOf(x) > -1) return "i";
        if ("óòöô".indexOf(x) > -1) return "o";
        if ("úùüû".indexOf(x) > -1) return "u";
        if (x === "ñ") return "nzzz";
        if (x === "ç") return "czzz";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.recipe:nth-child(even) {
  background-color: lightgrey !important;
}
.recipe:nth-child(odd) {
  background-color: white !important;
}
.recipes {
  position: relative;
  height: 100%;
  overflow: scroll;
}
.data-frame {
  text-align: right;
  .rating-frame {
    display: inline-block;
    .stars {
      display: inline-block;
    }
    .rating {
      font-size: 0.8em;
      width: 40px;
      text-align: center;
      font-weight: bold;
      color: grey;
    }
  }
  .comments {
    font-size: 0.8em;
    cursor: pointer;
    text-decoration: underline;
    color: darkblue;
    display: block;
    margin-top: 0px;
    margin-bottom: 3px;
  }
}
.no-comments {
  font-size: 0.8em;
  color: grey;
  display: block;
  margin-top: 0px;
  margin-bottom: 3px;
}
</style>